/** Active alignment cloud — fixed dark violet, distinct from per-sensor aligned colors. */
export const ACTIVE_ALIGNMENT_CLOUD_COLOR = '#6b21a8';

const ALIGNED_CLOUD_SATURATION = 85;
const ALIGNED_CLOUD_LIGHTNESS = 36;
const ACTIVE_VIOLET_HUE_MIN = 265;
const ACTIVE_VIOLET_HUE_MAX = 305;

const hashSensorId = (sensorId: string): number => {
  let hash = 0;
  for (let i = 0; i < sensorId.length; i += 1) {
    hash = sensorId.charCodeAt(i) + ((hash << 5) - hash);
  }
  return Math.abs(hash);
};

/** Per-sensor color for aligned scans — dark/saturated for light floor plans. */
export const alignedSensorColor = (sensorId: string): string => {
  let hue = hashSensorId(sensorId) % 360;
  if (hue >= ACTIVE_VIOLET_HUE_MIN && hue <= ACTIVE_VIOLET_HUE_MAX) {
    hue = (hue + 120) % 360;
  }
  return `hsl(${hue}, ${ALIGNED_CLOUD_SATURATION}%, ${ALIGNED_CLOUD_LIGHTNESS}%)`;
};
